import React from 'react'

import { MUIButton } from 'components/common/MUIButton'
import { usePfEntryPrimaryAction } from './usePfEntryPrimaryAction'

interface Props {
  /** Label for the button */
  primaryLabel: string
  /** Called when the user should see the property-selection drawer (overlay over current page) */
  onOpenPropertyDrawer: () => void
}

/**
 * TopBar "New order" button for the PF Revamp entry point: one primary button, as in Figma. It opens the
 * property-selection drawer, which also lists the client's saved orders; admins see its client-selection stage first.
 */
export const NewOrderButton: React.FC<Props> = ({ primaryLabel, onOpenPropertyDrawer }) => {
  const { handlePrimaryAction } = usePfEntryPrimaryAction({ onOpenPropertyDrawer })

  return (
    <MUIButton className="order-visuals-button" onClick={handlePrimaryAction}>
      {primaryLabel}
    </MUIButton>
  )
}
